import { render, staticRenderFns } from "./BindForm.vue?vue&type=template&id=16941949&scoped=true&"
import script from "./BindForm.vue?vue&type=script&lang=js&"
export * from "./BindForm.vue?vue&type=script&lang=js&"
import style0 from "./BindForm.vue?vue&type=style&index=0&id=16941949&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16941949",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/vue-sellerwell-web-erp-service-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16941949')) {
      api.createRecord('16941949', component.options)
    } else {
      api.reload('16941949', component.options)
    }
    module.hot.accept("./BindForm.vue?vue&type=template&id=16941949&scoped=true&", function () {
      api.rerender('16941949', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/modules/BindForm.vue"
export default component.exports